<div
  (click)="overlayClicked($event)"
  class="notifications-overlay"
  [class.visible]="visible"
  (keydown)="handleKeys($event)"
  >
  <div
    class="notifications-tray"
    [class.visible]="visible"
    [class.hidden]="hidden"
    [class.touchable]="touchable"
    [style.margin-top]="(wideAlerts.length*2)+'em'"
    >

    <a #userCard [routerLink]="publicProfile" *ngIf="user" class="user-card">
      <img [src]="user?.profile?.avatar || '/assets/new-avatar.png'" alt="Your avatar image">
      <div>
        <div class="display-name">{{user.display_name}}</div>
        <div *ngIf="user.username" class="user-name">@{{user.username}}</div>
      </div>
    </a>

    <header>
      <span>Notifications</span>
    </header>

    <ng-container *ngIf="!list || list.length === 0">
      You have no notifications
    </ng-container>

    <mat-menu #notificationExtra>
      <ng-container *ngIf="!extraMenuNotification">
        <button mat-menu-item>No actions available</button>
      </ng-container>
      <ng-container *ngIf="extraMenuNotification">
        <button mat-menu-item *ngIf="!extraMenuNotification.extra_actions?.length">No actions available for this
          notification</button>
        <ng-container *ngFor="let action of extraMenuNotification.extra_actions" >
          <a *ngIf="isUrlExternal(action.url)" mat-menu-item [href]="action.url" target="_blank">
            <mat-icon>{{action.icon}}</mat-icon>
            {{action.label}}
          </a>
          <a *ngIf="!isUrlExternal(action.url)" mat-menu-item [routerLink]="action.url">
            <mat-icon>{{action.icon}}</mat-icon>
            {{action.label}}
          </a>
        </ng-container>

      </ng-container>
    </mat-menu>

    <div #notificationListBox *ngIf="list?.length > 0" class="notifications-container">
      <div [class.attention]="notif.style === 'attention'" [class.muted]="notif.style === 'muted'" class="notification"
        *ngFor="let notif of list">

        <div [class.visible]="showUnseenMarkers" class="notification-unseen-marker"></div>

        <div *ngIf="notif.image" class="notification-image">
          <img [src]="notif.image" alt="">
        </div>
        <div class="notification-icon" [ngClass]="{'icon-overlay': notif.image }">
          <mat-icon *ngIf="!notif.icon">{{notif.category}}</mat-icon>
          <mat-icon *ngIf="notif.icon">{{notif.icon}}</mat-icon>
        </div>
        <div class="notification-content">
          <a *ngIf="isUrlExternal(notif.url)" class="description" [href]="notif.url"
            [target]="notif.open_in_new_tab !== false ? '_blank' : '_self'">
            {{notif.description}}
          </a>
          <a *ngIf="!isUrlExternal(notif.url)" class="description" [routerLink]="notif.url">
            {{notif.description}}
          </a>

          <tyt-timestamp *ngIf="notif.timestamp" [value]="notif.timestamp"></tyt-timestamp>
        </div>
        <div class="notification-actions">
          <a href="javascript:;" *ngIf="notif.extra_actions?.length > 0" [matMenuTriggerFor]="notificationExtra"
            (click)="extraMenuNotification = notif">
            <mat-icon>more_vert</mat-icon>
          </a>
        </div>
      </div>

      <div *ngIf="hasMoreItems" class="more-row">
        <app-spinner class="inline line" *ngIf="loading" ></app-spinner>
        <a *ngIf="!loading" (click)="loadMore()" href="javascript:;">Load more</a>
      </div>

    </div>


    <div class="footer">

      <a routerLink="settings" class="button-action">
        <mat-icon>settings</mat-icon>
        Settings
      </a>

      <a routerLink="/logout" class="button-action">
        <svg viewBox="0 0 23 15" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.8125 5.625V7.5H9.875V9.375H8V7.5H5.96562C5.58125 8.59688 4.54063 9.375 3.3125 9.375C2.56658 9.375 1.85121 9.07868 1.32376 8.55124C0.796316 8.02379 0.5 7.30842 0.5 6.5625C0.5 5.81658 0.796316 5.10121 1.32376 4.57376C1.85121 4.04632 2.56658 3.75 3.3125 3.75C4.54063 3.75 5.58125 4.52812 5.96562 5.625H10.8125ZM3.3125 5.625C3.06386 5.625 2.8254 5.72377 2.64959 5.89959C2.47377 6.0754 2.375 6.31386 2.375 6.5625C2.375 6.81114 2.47377 7.0496 2.64959 7.22541C2.8254 7.40123 3.06386 7.5 3.3125 7.5C3.56114 7.5 3.7996 7.40123 3.97541 7.22541C4.15123 7.0496 4.25 6.81114 4.25 6.5625C4.25 6.31386 4.15123 6.0754 3.97541 5.89959C3.7996 5.72377 3.56114 5.625 3.3125 5.625ZM15.5 9.375C18.0031 9.375 23 10.6313 23 13.125V15H8V13.125C8 10.6313 12.9969 9.375 15.5 9.375ZM15.5 7.5C14.5054 7.5 13.5516 7.10491 12.8483 6.40165C12.1451 5.69839 11.75 4.74456 11.75 3.75C11.75 2.75544 12.1451 1.80161 12.8483 1.09835C13.5516 0.395088 14.5054 0 15.5 0C16.4946 0 17.4484 0.395088 18.1516 1.09835C18.8549 1.80161 19.25 2.75544 19.25 3.75C19.25 4.74456 18.8549 5.69839 18.1516 6.40165C17.4484 7.10491 16.4946 7.5 15.5 7.5Z"
            fill="currentColor" />
        </svg>
        Log Out
      </a>

    </div>

  </div>
</div>
